<template>
  <div>
    <iframe v-if="url" :src="url" :width="ssowidth" :height="ssoheight" class="iframe" frameborder="0" scrolling="no" hspace="100" vspace="-150" style="position:absolute;top: 0;left: 0px;"></iframe>
  </div>
</template>
<script>
export default {
  name: 'APP',
  props: ['url', 'ssoheight', 'ssowidth'],
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
  },
}
</script>
<style lang="scss" scoped>
.iframe {
  border-radius: 16px;
}
</style>
